import { Link } from 'react-router-dom'
import { ArrowRight, BookOpen, Calculator } from 'lucide-react'
import { Container } from '@/components/layout/Container'
import { AnimateIn } from '@/components/motion/AnimateIn'
import { PATHS } from '@/routes/paths'
import { SECTION_PY } from '@/lib/layoutSpacing'

const tools = [
  {
    title: 'Cost Estimator',
    description: 'Estimate construction material costs by built-up area and convert land units instantly.',
    href: PATHS.calculator,
    icon: Calculator,
    cta: 'Open estimator',
  },
  {
    title: 'Real Estate Information',
    description: 'Watch guides, browse book links, and get Real Estate Guide Book & agreement details.',
    href: PATHS.realEstateBook,
    icon: BookOpen,
    cta: 'View information',
  },
] as const

export function ToolsResourcesSection() {
  return (
    <section className={SECTION_PY} aria-labelledby="home-tools-heading">
      <Container>
        <AnimateIn>
          <div className="mx-auto max-w-2xl text-center">
            <p className="text-[10px] font-semibold uppercase tracking-wider text-primary-600 md:text-[11px]">
              Tools &amp; guides
            </p>
            <h2
              id="home-tools-heading"
              className="mt-1 font-display text-lg font-bold text-qbc-navy md:text-xl"
            >
              Cost Estimator &amp; Real Estate Information
            </h2>
            <p className="mt-1.5 text-sm text-neutral-600">
              Same tools available in the QBC app — now on the website.
            </p>
          </div>

          <div className="mt-6 grid gap-4 md:mt-8 md:grid-cols-2">
            {tools.map(({ title, description, href, icon: Icon, cta }) => (
              <Link
                key={href}
                to={href}
                className="group flex h-full flex-col rounded-2xl border border-neutral-200/90 bg-white p-5 shadow-[0_8px_30px_rgba(15,93,154,0.06)] transition-all hover:border-primary-200 hover:shadow-[0_12px_36px_rgba(15,93,154,0.1)] md:p-6"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-50 text-primary-600 transition-colors group-hover:bg-primary-100">
                  <Icon className="h-5 w-5" strokeWidth={1.75} />
                </span>
                <h3 className="mt-4 font-display text-base font-bold text-qbc-navy md:text-lg">{title}</h3>
                <p className="mt-1.5 flex-1 text-sm leading-relaxed text-neutral-600">{description}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600">
                  {cta}
                  <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                </span>
              </Link>
            ))}
          </div>
        </AnimateIn>
      </Container>
    </section>
  )
}
